import { useState } from "react";
import { waLink } from "../data";

export const LeadForm = () => {
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", mensagem: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    const msg = `Olá! Meu nome é ${form.nome}. ${form.mensagem} (Contato: ${form.telefone}${form.email ? " / " + form.email : ""})`;
    window.open(waLink(msg), "_blank");
  };
  return (
    <section className="lead-banner" id="contato" data-testid="lead-form-section">
      <div className="container lead-grid">
        <div className="lead-text">
          <span className="badge green">Atendimento 24hs</span>
          <h2>Receba atendimento pelo WhatsApp</h2>
          <p>
            Preencha em menos de 30 segundos e fale com a equipe de plantão. Emergência,
            orçamento ou dúvida — resposta em minutos, a qualquer hora.
          </p>
          <p className="lead-note">
            Sem compromisso. Atendimento emergencial conforme disponibilidade da equipe.
          </p>
        </div>
        <form className="lead-form" onSubmit={submit} data-testid="lead-form">
          <input required placeholder="Nome" value={form.nome} onChange={set("nome")} data-testid="lead-form-name" />
          <input type="email" placeholder="E-mail" value={form.email} onChange={set("email")} data-testid="lead-form-email" />
          <input required placeholder="Telefone" value={form.telefone} onChange={set("telefone")} data-testid="lead-form-phone" />
          <textarea required rows="3" placeholder="Detalhes do problema (cidade, tipo de entupimento…)" value={form.mensagem} onChange={set("mensagem")} data-testid="lead-form-message" />
          <button type="submit" data-testid="lead-form-submit-button">💬 CONVERSAR</button>
        </form>
      </div>
    </section>
  );
};
